import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { AthleteStatus, AthleteStatusUpdateSerialzer, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAthleteStatus(): UseMutationResult<
  AxiosResponse<AthleteStatus>,
  AxiosError<ErrorMessage>,
  AthleteStatusUpdateSerialzer
> {
  const queryClient = useQueryClient();

  const updateAthleteStatus = (
    athleteStatus: AthleteStatusUpdateSerialzer,
  ): Promise<AxiosResponse<AthleteStatus>> => {
    return client.put(`athlete-statuses/${athleteStatus.athleteStatusId}/`, athleteStatus);
  };

  return useMutation(updateAthleteStatus, {
    onSuccess: response => {
      queryClient.invalidateQueries({
        queryKey: ['athleteStatuses'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athletes', response.data.athlete],
      });
    },
  });
}
